import request from "@/api/request";
import { DialogList } from "@/interfaces/Messages/DialogList";
import { NewMessage } from "@/interfaces/Messages/NewMessage";
import { Message } from "@/interfaces/Messages/Message";
import { PlaydateCamera } from "@/interfaces/Playdates/PlaydateCamera";
import { TransactionalMessage } from "@/interfaces/TransactionalMessage/TransactionalMessage";

class MessageService {
  static async getDialogs(page: number): Promise<DialogList> {
    return request.get("/messages", { page });
  }

  static async getNewMessages(timestamp: number | null): Promise<NewMessage> {
    return request.get("/messages/new_messages", { last_message_timestamp: timestamp });
  }

  static async getDialogMessages(type: string, name: string | number | null = null): Promise<Message[]> {
    let path = `/messages/${type}`;

    if (name !== null) {
      path += `/${name}`;
    }

    return request.get(path);
  }

  static async deleteDialogWith(type: string, name: string): Promise<void> {
    await request.delete(`/messages/${type}/${name}`);
  }

  static async sendMessage(type: string, name: string, formData: FormData): Promise<Message> {
    return await request.post(`/messages/${type}/${name}`, formData);
  }

  static async getPlaydateConversationCameras(conversationId: number): Promise<PlaydateCamera[]> {
    return await request.get("/messages/playdate_cameras", { id: conversationId });
  }

  static async getTransactionalMessagePopup(): Promise<TransactionalMessage | null> {
    return request.get("/messages/transactional/popup");
  }

  static async unsubscribeTransactionalMessageGroup(group: string): Promise<void> {
    return request.put(`/messages/unsubscribe/${group}`);
  }
}

export default MessageService;
